/*
/*
 * Page Name
 */

(function ($) {

    var gallaries_scroll = jQuery('.gallaries_scroll');
    if (gallaries_scroll.length > 0) {
        gallaries_scroll.each(function () {
            var _this_scroll = jQuery(this);
            var _this_scroll_length = _this_scroll.find('img').length;
            var _this_scroll_content = _this_scroll.find('.gallaries_scroll__inner').html();
            var _this_scroll_speed = jQuery(this).data('speed') || _this_scroll_length * 3000;

            _this_scroll.find('.gallaries_scroll__inner').remove();
            _this_scroll.append(
                '<div class="gallaries_scroll__inner" style="--speed:' + _this_scroll_speed + 'ms;">' + _this_scroll_content + '</div>' +
                '<div class="gallaries_scroll__inner" style="--speed:' + _this_scroll_speed + 'ms;">' + _this_scroll_content + '</div>'
            );
        });
    }

    var ind_block01_galleries = jQuery('.ind_block01_galleries');
    if (ind_block01_galleries.length > 0) {
        ind_block01_galleries.each(function () {
            var _this_scroll = jQuery(this).find('.ind_block01_galleries_box');
            var _this_scroll_length = _this_scroll.find('div').length;
            var _this_scroll_content = _this_scroll.html();
            var speed = jQuery(this).data('speed') || _this_scroll_length * 5000;

            _this_scroll.remove();
            jQuery(this).append(
                '<div class="ind_block01_galleries__scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>' +
                '<div class="ind_block01_galleries__scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>'
            );
        });
    }

    var ind_block02_work_list = jQuery('.ind_block02_work_list li');
    var ind_block02_work_box = jQuery('.ind_block02_work_box');

    if (ind_block02_work_list.length > 0) {
        ind_block02_work_list.on('click', function (e) {
            e.preventDefault();
            var _thischange = jQuery(this);
            var _targetchange = _thischange.data('area');

            ind_block02_work_list.removeClass("active");
            ind_block02_work_box.removeClass("active");

            _thischange.toggleClass("active");
            jQuery('.ind_block02_work_box[data-area="' + _targetchange + '"]').toggleClass("active");
        })
    }

})(jQuery);